import styled, { css, keyframes } from 'styled-components';

// The implementation of animations will change when the enhanced functionality for
// animations is created
const progressBarAnimation = keyframes`
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
`;

const ProgressBarContainer = styled.div`
  z-index: 5;
  width: 100%;
  transform: translate(0, 0);
  transition: all 0.5s ease-out;
  height: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.colors.neutral.gray[300]};

  > div {
    ${({ theme, progress }) => css`
      height: 100%;
      width: ${progress};
      background: linear-gradient(
        to right,
        ${theme.colors.support.success[600]} 0%,
        ${theme.colors.support.success[200]} 50%,
        ${theme.colors.support.success[600]} 100%
      );
    `}

    background-size: 200% 100%;
    animation: ${progressBarAnimation} 3s linear infinite;
  }

  ${({ isCardSelected }) => isCardSelected && css`
    transform: translate(0, 50%);
  `}
`;

export { ProgressBarContainer };
